import PropTypes from 'prop-types';
import { css, cx } from '@eti/styles';
import { StackedIcon } from '@eti/components';

const blockClass = (image) => css`
  background-image: url(${image});
  background-position: center;
  background-size: cover;
  display: flex;
  height: 163px;
  width: 100%;

  @media (min-width: 62em) {
    height: 216px;
  }
`;

const blockContainerClass = css`
  height: 48.6933%;
  width: 48.6933%;

  @media (min-width: 48em) {
    width: 22%;
  }

  @media (min-width: 62em) {
    width: 24.3467%;
  }
`;

const iconClass = css`
  height: 44px;
  margin: 1em 0 0 1em;
  width: 44px;

  [dir='rtl'] & {
    margin: 1em 1em 0 0;
  }
`;

const labelClass = css`
  display: block;
  margin: 0.5em 0 0;
`;

const ReceiptProductBlock = ({ icons, image, labelText, postBookingUrl }) => (
  <div className={blockContainerClass}>
    <a data-testid="receipt-ReceiptProductBlock" href={postBookingUrl}>
      <div className={blockClass(image)}>
        <StackedIcon className={iconClass} icons={icons} />
      </div>
    </a>
    <span className={cx(labelClass, 'product-label')}>{labelText}</span>
  </div>
);

ReceiptProductBlock.propTypes = {
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      className: PropTypes.string,
      colors: PropTypes.arrayOf(PropTypes.string),
      id: PropTypes.string,
    }),
  ),
  image: PropTypes.string,
  labelText: PropTypes.string,
  postBookingUrl: PropTypes.string,
};

export default ReceiptProductBlock;
